import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import * as CampaignModel from "@/models/campaign";
import { cloneDeep } from "lodash";
import { MetaPagination } from "@/models/general";

export interface CampaignState {
  currentCampaign: CampaignModel.default;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "campaign",
})
class Campaign extends VuexModule implements CampaignState {
  currentCampaign: CampaignModel.default = new CampaignModel.default();
  filter: CampaignModel.CampaignFilters = new CampaignModel.CampaignFilters();
  pagination: MetaPagination = new MetaPagination();
  sort?: { key: string; order: string };

  get getCurrentCampaign() {
    return this.currentCampaign;
  }

  get getCurrentFilter() {
    return this.filter;
  }

  get getPagination() {
    return this.pagination;
  }

  get getSort() {
    return this.sort;
  }

  @Mutation
  setCurrentCampaign(campaign: CampaignModel.default) {
    this.currentCampaign = cloneDeep(campaign);
  }

  @Mutation
  setCampaignFilter(filter: CampaignModel.CampaignFilters) {
    this.filter = cloneDeep(filter);
  }

  @Mutation
  setPagination(pagination: MetaPagination) {
    this.pagination = cloneDeep(pagination);
  }

  @Mutation
  setSort(order: { key: string; order: string }) {
    this.sort = {
      key: order.key,
      order: order.order,
    };
  }
}

export const CampaignModule = getModule(Campaign);
